import styled from 'styled-components';

export const _InputWrapper = styled('div').withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['errorIsARequiredField'].includes(prop) && defaultValidatorFn(prop),
})`
  font-family: aktiv-grotesk, sans-serif;

  input {
    border: 1px solid #1d1d1b;
    border-radius: 0;
    box-sizing: border-box;
    color: #1d1d1b;
    font-size: 1em;
    font-weight: 500;
    padding: 22px 12px;
    margin-bottom: 16px;
    width: 100%;
    height: 50px;

    &:focus {
      border-color: ${(props) => props.theme.black};
      box-shadow: inset 0 0 3px #1b5f4b;
      background-color: ${(props) => props.theme.lightGray};
    }

    &.error {
      border-color: red;
      box-shadow: inset 0 0 3px red;
    }
  }
`;
